import { render, staticRenderFns } from "./ProfileHistory.vue?vue&type=template&id=01b5df00&scoped=true"
import script from "./ProfileHistory.vue?vue&type=script&lang=js"
export * from "./ProfileHistory.vue?vue&type=script&lang=js"
import style0 from "./ProfileHistory.vue?vue&type=style&index=0&id=01b5df00&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5df00",
  null
  
)

export default component.exports